import {API_ENDPOINTS} from "../constants";

import {API_URL} from "../config";
import {postDataWithSession, postMultipartData, returnFileFromApi} from "./index";

export const putFile = (queryParams, body) => {
  const postQueryParams = new URLSearchParams(queryParams);
  const formData = new FormData();
  formData.append('file', body.file);
  formData.append('bucket', body.bucket);
  formData.append('filename', body.filename);

  const options = {
    body: formData
  }

  return postMultipartData(`${API_URL}/${API_ENDPOINTS.PUT_FILE}?${postQueryParams}`, options);
}

export const getFile = (queryParams, body) => {
  const formData = new FormData();
  formData.append('bucket', body.bucket);
  formData.append('filename', body.filename);

  const options = {
    body: formData
  }

  return returnFileFromApi(queryParams, `${API_URL}/${API_ENDPOINTS.GET_FILE}`, options);
}

export const deleteFile = (queryParams, body) => {
  const postQueryParams = new URLSearchParams(queryParams);
  const formData = new FormData();
  formData.append('bucket', body.bucket);
  formData.append('filename', body.filename);

  const options = {
    body: formData
  }

  return postMultipartData(`${API_URL}/${API_ENDPOINTS.DELETE_FILE}?${postQueryParams}`, options);
}

export const getReport = (endpoint, queryParams, returnList= false) => {
  return postDataWithSession(queryParams, `${API_URL}/reporting/${endpoint}`, {}, returnList);
}

export const getPdfReport = (queryParams) => {
  return returnFileFromApi(queryParams, `${API_URL}/${API_ENDPOINTS.GET_PDF_REPORT}`, {});
}